import { useContext, useEffect, useState } from 'react';

import { try_get_querystring_value } from '../querystring';
import { API_URL } from '../config';

import { PageLayout } from '../components/page-layout';
import { LoadingContainer } from '../components/loading-container';
import { InputBox } from '../components/input-box';
import { ErrorMessage } from '../components/error-message';
import { CustomerColors } from '../components/customer-colors';

import './onboarding.css';
import {
    APPLICATION_WAS_IMPORTED_SUCCESSFULLY,
    ATEA_RESET_ONBOARDING,
    ENTER_YOUR_TENANT_ID_OR_DOMAIN,
    ONBOARDING_INSTRUCTIONS
} from '../translator/phrase-keys';
import { LanguageContext } from '../components/language-settings';

export function OnboardingPage() {
    const [loading, setLoading] = useState(false);
    const [tenant, setTenant] = useState("");
    const [view, setView] = useState("");
    const [error, setError] = useState("");
    const {translator} = useContext(LanguageContext);

    useEffect(() => {
        if (application_was_imported()) {
            setView("imported");
            return;
        }

        const [failed, error_message] = application_failed_to_import();
        if (failed) {
            setView("failed");
            setError(error_message);
            return;
        }

        setView("onboard");
    }, []);

    async function importApplication() {
        setLoading(true);

        const redirect_url = window.location.href;

        const response = await fetch(`${API_URL}/api/import/${tenant}?redirect_url=${redirect_url}`, {
            method: "GET",
            headers: {
                'Content-Type': 'application/json',
            },
        });

        if (!response.ok) {
            if (response.status === 400) {
                const error_message = await response.text();
                setView("onboard");
                setError(error_message);
                return;
            }

            setLoading(false);
            return;
        }

        let url = await response.text();
        window.location.href = url;
    }

    return (<>
        <PageLayout
            image="svg/onboarding.svg"
            title={translator.translate(ATEA_RESET_ONBOARDING) }
            description={view === "onboard" ? translator.translate(ONBOARDING_INSTRUCTIONS) : ""}>
            <LoadingContainer loading={loading}>
                {view === "onboard" && <InputBox
                    value={tenant}
                    onValueChange={value => setTenant(value)}
                    onButtonClicked={() => importApplication()}
                    placeholder={translator.translate(ENTER_YOUR_TENANT_ID_OR_DOMAIN)}
                    focusOnInit="true"
                />}
                {view === "imported" && <ImportSucceeded text={translator.translate(APPLICATION_WAS_IMPORTED_SUCCESSFULLY)} /> }
                {view === "failed" && <ImportFailed /> }
                {error && <ErrorMessage text={translator.translate(error)} /> }
            </LoadingContainer>
        </PageLayout>
        <CustomerColors />
    </>);
}

function ImportFailed() {
    return (
        <div className="app-import">
            <img src="svg/failed.svg" alt="" />
        </div>
    );
}

function ImportSucceeded({text}) {
    return (
        <div className="app-import">
            <img src="svg/imported.svg" alt="" />
            <p>{text}</p>
        </div>
    );
}

function application_was_imported() {
    const [containsTenant, tenant] = try_get_querystring_value("tenant");
    const [containsAdminConsent, adminConsent] = try_get_querystring_value("admin_consent");

    if (!containsTenant)
        return false;

    if (!tenant)
        return false;

    if (!containsAdminConsent)
        return false;

    if (adminConsent !== "True")
        return false;

    return true;
}

function application_failed_to_import() {
    const [containsErrorDesc, errorDesc] = try_get_querystring_value("error_description");
    if (containsErrorDesc)
        return [true, errorDesc];

    const [containsError, error] = try_get_querystring_value("error");
    if (containsError)
        return [true, error];

    return [false, ""];
}